mutation GenerateReport($input: GenerateReportInput!) {
    generateReport(input: $input) {
        savedFilter {
            id
            name
            htmlUrlPath
            description
            type
        }
        status
    }
}
